import React from 'react';
import { Portal } from './portal';

interface PlayerFullscreenPortalProps {
  children: React.ReactNode;
}

export function PlayerFullscreenPortal({ children }: PlayerFullscreenPortalProps) {
  return <Portal selector={document.querySelector('.player-fullscreen-wrapper')}>{children}</Portal>;
}
